import { Box, Divider, Grid } from "@mui/material";
import { Formik } from "formik";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/common/Button";
import OrganizationStructure from "../../../components/common/OrganizationStructure/OrganizationStructure";
import { NEW_FRIEND_FIELDS } from "../../../contants/formFields";
import MembersApi from "../../../services/api/member";
import { handleNewMemberValidation } from "../../../utils";
import { debounce } from "../../../utils/helper";
import NewFriendForm from "../NewMemberEntry";
import { CommonStyles } from "../../../components/common/Button/commonButtonStyle";
import Toast from "../../../components/common/Toast";
import { ROUTES } from "../../../utils/constants";

function NewMemberCreate() {
  const [isLoading, setIsLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const navigate = useNavigate();

  const onBack = () => navigate(-1);

  const postData = async (values) => {
    try {
      setIsLoading(true);
      const response = await MembersApi.postNewMember({
        data: values,
      });
      setTimeout(() => {
        navigate(ROUTES.MEMBER_SEARCH.path);
      }, 2000);
      if (response) {
        setShowToast({
          message: "Form submitted successfully",
          severity: "success",
        });
      }
      setIsLoading(false);
    } catch (err) {
      setShowToast({ message: err.message, severity: "error" });
      setIsLoading(false);
    }
  };

  return (
    <>
      <Grid container>
        <Formik
          initialValues={{}}
          onSubmit={debounce((values) => {
            const result = handleNewMemberValidation(NEW_FRIEND_FIELDS, values);
            if (result && Object.keys(result).length) {
              setShowToast(result);
              return;
            }
            postData(values);
          })}
        >
          {({ values, errors, handleChange, handleSubmit, setFieldValue }) => (
            <>
              <Box display="flex" gap="30px">
                <Grid item md={8} sm={12}>
                  <NewFriendForm
                    values={values}
                    handleChange={handleChange}
                    errors={errors}
                    setFieldValue={setFieldValue}
                  />
                </Grid>
                <Grid item md={4} sm={12}>
                  <OrganizationStructure
                    values={values}
                    handleChange={handleChange}
                    errors={errors}
                    handleSubmit={handleSubmit}
                    setFieldValue={setFieldValue}
                    isLoading={isLoading}
                    showZoneLocator={false}
                    showBlock
                  />
                </Grid>
              </Box>
              <Divider
                sx={{
                  display: "flex",
                  width: "100%",
                  paddingTop: "1%",
                  marginBottom: "30px",
                }}
              />
              <div style={{ display: "flex", gap: 5 }}>
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  isLoading={isLoading}
                  style={CommonStyles.buttonStyle}
                  label="Submit"
                  type="submit"
                />
                <Button
                  variant="outlined"
                  onClick={onBack}
                  label="Cancel"
                  style={{
                    ...CommonStyles.buttonStyle,
                    marginLeft: "20px",
                  }}
                />
              </div>
            </>
          )}
        </Formik>
      </Grid>
      <Toast
        open={!!showToast}
        severity={showToast?.severity || ""}
        message={showToast?.message || ""}
        handleClose={() => {
          setShowToast(null);
        }}
      />
    </>
  );
}

export default NewMemberCreate;
